import { App, Button } from "antd"
import { useEffect } from "react"

import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import { fetchUserInfo } from "../../User/redux/user.thunks"
import { type Notification } from "../types/notification.types.ts"

interface NotificationsPermissionsAlertProps {
  permissionsNotification: Notification
  onMarkAsRead: (notificationId: number | null) => void
  onPermissionsNotification: () => void
}

export function NotificationsPermissionsAlert({
  permissionsNotification,
  onMarkAsRead,
  onPermissionsNotification
}: NotificationsPermissionsAlertProps) {
  const dispatch = useAppDispatch()
  const { notification, modal } = App.useApp()

  useEffect(() => {
    notification.warning({
      key: "permissions-alert",
      message: "Your permissions have been updated.",
      description: "Please apply the changes to continue working.",
      duration: 0,
      btn: (
        <Button
          type={"primary"}
          onClick={() => {
            modal.confirm({
              title: "Apply new permissions?",
              content: (
                <div className="flex flex-col gap-2">
                  <p>Any unsaved data will be lost.</p>
                  <p>
                    If you lose access to certain actions after applying, please
                    contact your administrator to grant the required
                    permissions.
                  </p>
                </div>
              ),
              okText: "Apply",
              cancelText: "Cancel",
              onOk: async () => {
                onMarkAsRead(permissionsNotification.id)
                await dispatch(fetchUserInfo())
                notification.destroy("permissions-alert")
                onPermissionsNotification()
              }
            })
          }}
        >
          Apply
        </Button>
      ),
      closeIcon: false
    })
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- the alert is raised once when this mounts and stays until the user applies the changes
  }, [])

  return null
}
